import { CellProps } from 'react-table'
import { EspecialidadeView } from '../../core/_models'
import { EspecialidadeActionsCell } from './EspecialidadeActionsCell'
import {
  ChipListCell,
  PlainHeader,
  sortableColumn,
  StackedCell,
  StatusBadge,
  TableColumn,
} from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { TFunction } from '_metronic/i18n/Metronici18n'

/** Descrições legíveis dos tipos de atendimento (o map traz a descrição; o array só o código). */
const tiposAtendimento = (especialidade: EspecialidadeView): string[] =>
  especialidade.tiposAtendimentoMap?.length
    ? especialidade.tiposAtendimentoMap
        .map((tipo) => tipo.descricao ?? tipo.name ?? '')
        .filter(Boolean)
    : (especialidade.tiposAtendimento ?? []).map(String)

const especialidadesColumns = (t: TFunction): ReadonlyArray<TableColumn<EspecialidadeView>> => [
  // Conselho é a linha de apoio do nome, quando a especialidade tiver um.
  sortableColumn<EspecialidadeView>({
    id: 'nome',
    useQueryRequest,
    fields: [
      { field: 'nome', label: t('cols.nome') },
      { field: 'conselho', label: t('cols.conselho') },
    ],
    Cell: ({ row }: CellProps<EspecialidadeView>) => (
      <StackedCell
        primary={row.original.nome}
        secondary={row.original.conselho?.sigla ?? row.original.conselho?.nome}
      />
    ),
  }),
  {
    Header: () => <PlainHeader>Tipos de atendimento</PlainHeader>,
    id: 'tipo',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<EspecialidadeView>) => (
      <ChipListCell
        items={tiposAtendimento(row.original)}
        max={3}
        noun={{ singular: 'tipo de atendimento', plural: 'tipos de atendimento' }}
      />
    ),
  },
  sortableColumn<EspecialidadeView>({
    id: 'ativa',
    cellWidth: '128px',
    useQueryRequest,
    fields: [{ field: 'ativa', label: t('cols.status') }],
    Cell: ({ row }: CellProps<EspecialidadeView>) => (
      <StatusBadge active={row.original.ativa} labels={['Ativa', 'Inativa']} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<EspecialidadeView>) => (
      <EspecialidadeActionsCell especialidade={row.original} />
    ),
  },
]

export { especialidadesColumns }
